import { RouterOutlet } from '@angular/router';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { HeaderComponent } from '@/app/core/components/header';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, HeaderComponent, CdkScrollable],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent {}
